
import React, { useState, useEffect } from "react";
import { Button, Spin } from "antd";
import { createProcuringEntity, updateException } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const ProcuringEntityComponent = ({ exception, onClose, onResolved }) => {
    const [councilId, setCouncilId] = useState(null);
    const [projectId, setProjectId] = useState(null);
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        const extractIds = () => {
            setCouncilId(exception?.council_id);
            setProjectId(exception?.project_id);
        };

        if (exception && exception.description) {
            extractIds(exception.description);
        }
    }, [exception]);

    const handleMarkAsNew = async () => {
        setLoading(true); 
        if (councilId && projectId) {
            if (exception.status === 'pending') {
                try {
                    const response = await createProcuringEntity({
                        council_id: councilId,
                        project_id: projectId,
                    });
                    console.log("After creating procuring entity",response);
                    await updateException(exception.id);
                    console.log(`Procuring entity created successfully with Council ID: ${councilId} and Project ID: ${projectId}`);
                    // Notify parent so it can refresh exceptions/projects and enable menus
                    try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                    onClose();
                } catch (error) {
                    console.error(`Failed to create procuring entity with Council ID: ${councilId} and Project ID: ${projectId}`, error);
                    try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                    onClose();
                } finally {
                    setLoading(false); 
                }
            } else {
                console.warn("Exception already resolved.");
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            }
        } else {
            console.warn("Required IDs not found.");
            setLoading(false); 
            onClose();
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <Button 
                        type="primary" 
                        onClick={handleMarkAsNew}
                        disabled={loading}
                        loading={loading}
                    >
                        Mark as New
                    </Button>
                </Spin>
            </Hide>
        </div>
    );
};

export default ProcuringEntityComponent;
